import React, { Component } from "react";
import { Link } from "react-router-dom";
import Table from "../common/table/table";

class LeaguesTable extends Component {
  columns = [
    {
      key: "edit",
      className: "col-1",
      content: league => (
        <Link to={`/leagues/${league.id}`} className="btn btn-info btn-sm">
          <i className="fa fa-edit" />
        </Link>
      )
    },
    {
      key: "delete",
      className: "col-1",
      content: league => (
        <button
          onClick={() => this.props.onDelete(league)}
          className="btn btn-danger btn-sm"
        >
          <i className="fa fa-trash" />
        </button>
      )
    },
    { key: "name", label: "Name", className: "col-6" },
    { key: "addInf", label: "Add. Inf.", className: "col-4" }
  ];

  render() {
    const { leagues, onSort, sortColumn } = this.props;

    return (
      <div className="container">
        <Table
          columns={this.columns}
          sortColumn={sortColumn}
          onSort={onSort}
          data={leagues}
        />
      </div>
    );
  }
}

export default LeaguesTable;



// WEBPACK FOOTER //
// ./src/components/leagues/leaguesTable.jsx